function tourNavTemplate (steps, totalSteps) {
  return `
    <div class="tour-popup-navigation">
      <div class="tour-steps-indicator-container">
        <span>${steps}/${totalSteps}</span>
        <img id="tourStart" class="tour-steps-arrow" src="./images/Tour_Arrows.svg" alt="Tour Steps Next Icon" aria-label="Next Steps Tour" data-role='next' />
      </div>
    </div>
  `
}

config.tour = {
  steps: [
    {
      element: "#searchArea",
      title: "Search or click on the map",
      content: `
        <p>Drop a pin on the map, or enter an address or Goodman property name in the search field to begin.</p>
        ${tourNavTemplate(2,7)}
      `,
      placement: 'left'
    },
    {
      element: "#circle2",
      title: "Choose between drive-times or distance rings",
      content: `
        <p>A drive-time calculates the area that can be reached within a specified travel time or travel distance of a property along a street network based on travel mode (such as a car or truck).</p>
        <p>Distance rings calculate the area covering a specified distance from a property 'as the crow flies'. Distance rings do not use the street network.</p>
        <p>Please note that drive-time analysis does NOT work in mainland China. You can use distance rings for this market instead.</p>
        ${tourNavTemplate(3,7)}`,
      placement: 'left'
    },
    {
      element: "#circle3",
      title: "Create your area(s) around the starting point",
      content: `
        <p>Enter one, two or three times or distances in the three fields eg. 30, 45 and 60 minutes. In the case of a drive-time calculation, you can choose to change from car drive time to truck drive time.</p>
        <p>To see the drive time or distance ring area(s) on the map, press Calculate.</p>
        ${tourNavTemplate(4,7)}`,
      placement: 'left'
    },
    {
      element: '#btnCreateReport',
      title: "Create a demographic report",
      content: `
        <p>Select the VIEW KEY STATS button to generate a report displaying key statistics for the drive-time or ring area that you have created.
        The report includes the most popular statistics including population, age, purchasing power and more.</p>
        <p>To access more detailed statistics beyond what's included in this report, you will need to perform a drive-time analysis directly in the
        <a class='link' href='https://smartspace.goodman.com/arcgis/home/index.html' target='_blank'>SmartSpace portal</a>.</p>
        ${tourNavTemplate(5,7)}`,
      placement: 'left'
    },
    {
      element: "#imgBasemaps",
      title: "Change the base map",
      content: `
        <p>Select a different basemap if required, such as satellite imagery or roads.</p>
        ${tourNavTemplate(6,7)}
      `,
      placement: 'left'
    },
    {
      element: "#imgPaintbrush",
      title: "Styling your map",
      content: `
        <p>Style your drive time or ring area and pin colour so that they stand out clearly on the basemap you have selected.</p>
        ${tourNavTemplate(7,7)}
      `,
      placement: 'left'
    }
  ],
  template: `
    <div class='popover tour'>
      <div class='arrow'></div>
      <div class="tour-popup-cta-container">
        <img id="tourSplashClose" class="goodman-close-icon" src="./images/Close_Icon.svg" alt="Close Icon" aria-label="Close Splash Modal" data-role='end' />
      </div>
      <h3 class='popover-header'></h3>
      <div class='popover-body'></div>
    </div>
  `
};
